import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, Table, Badge, Btn, Input } from "@/components/erp/ui";
import { toast } from "sonner";

const LBL = { PENDING: "Menunggu persetujuan", APPROVED: "Disetujui", MISTAKE: "Tidak dihitung (kesalahan)", REJECTED: "Ditolak" };

const tm = (s) => (s ? new Date(s).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta" }) : "");

export const OvertimeClaims = () => {
  const [month, setMonth] = useState(() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; });
  const [d, setD] = useState(null);
  const load = () => api.get(`/overtime?month=${month}`).then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, [month]);
  const reason = async (r) => {
    const txt = window.prompt("Alasan lembur", r.reason || ""); if (!txt) return;
    const mistake = window.confirm("Apakah lembur ini untuk mengganti kesalahan sendiri? (OK = ya, Batal = tidak)");
    try { await api.post("/overtime/reason", { date: r.date, reason: txt, is_mistake: mistake }); toast.success("Alasan lembur dikirim ke owner / HR"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  const decide = async (r, decision) => {
    let note = "";
    if (decision !== "APPROVED") { note = window.prompt("Catatan (opsional)", ""); if (note === null) return; }
    try { await api.post("/overtime/decide", { employee_id: r.employee_id, date: r.date, decision, note }); toast.success(LBL[decision]); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  if (!d) return null;
  return (
    <Card className="p-5 mt-6" data-testid="overtime-claims">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <span className="font-semibold text-sm">Lembur</span>
        <span className="text-xs text-slate-500">Dihitung & dibayar hanya setelah disetujui owner / HR. Tolak bila tidak ada aktivitas kerja atau order sedikit. Lembur mengganti kesalahan tidak dihitung.</span>
        <Input type="month" data-testid="ot-month" value={month} onChange={(e) => setMonth(e.target.value)} className="ml-auto border border-slate-300 rounded-lg px-2 py-1 text-sm" />
      </div>
      <Table testid="ot-table" columns={["Karyawan", "Tanggal", "Shift", "Lembur", "Aktivitas saat lembur", "Alasan", "Status", ""]} rows={d.items} renderRow={(r) => (
        <tr key={`${r.employee_id}-${r.date}`} data-testid={`ot-row-${r.employee_id}-${r.date}`} className="border-b border-slate-100 last:border-0">
          <td className="px-4 py-3 font-medium">{r.name}</td>
          <td className="px-4 py-3 text-xs font-mono">{r.date}</td>
          <td className="px-4 py-3 text-xs">{r.shift}</td>
          <td className="px-4 py-3">{r.ot_raw} mnt<div className="text-[10px] text-slate-400">{tm(r.ot_from)}–{tm(r.ot_to)}</div>{r.status === "APPROVED" && <div className="text-[10px] text-emerald-600">dihitung {r.minutes} mnt</div>}</td>
          <td className="px-4 py-3 text-xs max-w-[240px]" data-testid={`ot-activity-${r.employee_id}-${r.date}`}>
            {!r.design_min && !r.stages?.length ? <span className="text-rose-600 font-medium">Tidak ada aktivitas tercatat</span> : <>
              {r.design_min > 0 && <div>Design {Math.floor(r.design_min / 60)}j {r.design_min % 60}m <span className="text-slate-400">({Math.round(r.design_min * 100 / Math.max(1, r.ot_raw))}% dari lembur)</span></div>}
              {r.stages?.length > 0 && <div className="text-slate-600">Tahap WO: {r.stages.join(", ")}</div>}
            </>}
          </td>
          <td className="px-4 py-3 text-xs">{r.reason || <span className="text-slate-400">belum diisi</span>}{r.is_mistake && <div className="text-[10px] text-rose-500">mengganti kesalahan</div>}</td>
          <td className="px-4 py-3"><Badge>{LBL[r.status]}</Badge>{r.decided_by && <div className="text-[10px] text-slate-400">{r.decided_by}{r.note ? ` \u00b7 ${r.note}` : ""}</div>}</td>
          <td className="px-4 py-3 text-right whitespace-nowrap">
            {r.employee_id === d.me && r.status === "PENDING" && <Btn variant="ghost" data-testid={`ot-reason-${r.date}`} onClick={() => reason(r)}>Isi alasan</Btn>}
            {d.can_decide && r.status === "PENDING" && <>
              <Btn data-testid={`ot-approve-${r.employee_id}-${r.date}`} onClick={() => decide(r, "APPROVED")} className="mr-1">Setujui</Btn>
              <Btn variant="ghost" data-testid={`ot-mistake-${r.employee_id}-${r.date}`} onClick={() => decide(r, "MISTAKE")} className="mr-1">Kesalahan</Btn>
              <Btn variant="ghost" data-testid={`ot-reject-${r.employee_id}-${r.date}`} onClick={() => decide(r, "REJECTED")}>Tolak</Btn>
            </>}
          </td>
        </tr>
      )} />
    </Card>
  );
};
